// extracted by mini-css-extract-plugin
module.exports = {"container":"Perpetrator_container__3Gkpd","page":"Perpetrator_page__1oT9F","section":"Perpetrator_section__3iWXE"};